import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostListener,
  Inject,
  Input,
  OnInit,
  Output
} from "@angular/core";
import {PANEL_DATA} from "../../../../commons/angular/services/panel.service";

export interface BringozMenuItem {
  name: string;
  action: string;
  iconName: string;
  disabled: boolean;
}

require('./bringoz-menu-panel.scss');
@Component({
  standalone: false,
  selector: 'app-bringoz-menu-panel',
  templateUrl: './bringoz-menu-panel.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BringozMenuPanelComponent {
  @Output() onClose = new EventEmitter<string | undefined>();

  constructor(@Inject(PANEL_DATA) public data: BringozMenuItem[]) { }

  onClick(item: BringozMenuItem) {
    if (item.disabled) {
      return;
    }

    this.close(item.action);
  }

  close(action?: string) {
    this.onClose.emit(action);
  }
}
